import React from 'react';
import rootLogger, { Logger } from 'loglevel';

export const AppLoggerContext: React.Context<Logger> = React.createContext( rootLogger as Logger );

export const useAppLogger = (): Logger => {
  return React.useContext( AppLoggerContext );
};
